import { useEffect } from 'react';
import { useReadContract } from 'wagmi';
import { SHOP_CONTRACT_ADDRESS, SHOP_CONTRACT_ABI } from '@config/contracts';

export interface ChestType {
  chestId: bigint;
  name: string;
  price: bigint;
  isActive: boolean;
}

export const useGetAllChestTypes = () => {
  const { data, isLoading, isError, error, refetch } = useReadContract({
    address: SHOP_CONTRACT_ADDRESS,
    abi: SHOP_CONTRACT_ABI,
    functionName: 'getAllChestTypes',
  });

  useEffect(() => {
    if (error) {
      console.error('  ❌ Contract Error:', error);
      console.error('  Error details:', {
        name: error.name,
        message: error.message,
      });
    }
  }, [error]);

  return {
    chestTypes: (data as ChestType[]) || [],
    isLoading,
    isError,
    error,
    refetch,
  };
};
